/**
 * Modular What's New entries for the "service" module: the work-orders list. `routes` use the real navigation screen names from AppNavigator.jsx.
 *
 * @type {Object[]}
 */
const serviceEntries = [
  {
    id: 'service-search-everything-2026-10',
    module: 'service',
    routes: [{screen: 'ManagementListScreen', params: {type: 'workOrders'}}],
    date: '2026-10-28',
    version: '4.16.0',
    global: false,
    type: 'improvement',
    title: {
      en: "🔎 Find any work order by anything on it",
      hu: "🔎 Bármelyik munkalap megtalálható bármi alapján",
      de: "🔎 Jeden Auftrag über beliebige Angaben finden",
      cn: "🔎 可通过任何信息找到工单",
      ro: "🔎 Găsești orice fișă de lucru după orice detaliu",
      svn: "🔎 Poiščite katerikoli delovni nalog po čemerkoli",
    },
    body: {
      en: "The work-orders list only searched the first 50 rows, and only by number and plate. Now the search box looks through every work order: by plate, VIN, vehicle make or model, customer, the name or SKU of a part or service on it, barcode and notes. Older work orders are no longer hidden below the first page.",
      hu: "A munkalap lista csak az első 50 sorban keresett, és csak szám és rendszám alapján. Mostantól a keresőmező minden munkalapot átnéz: rendszám, alvázszám, a jármű márkája vagy típusa, ügyfél, a rajta lévő alkatrész vagy szolgáltatás neve és cikkszáma, vonalkód és megjegyzések alapján. A régebbi munkalapok már nem bújnak el az első oldal alatt.",
      de: "Die Auftragsliste durchsuchte nur die ersten 50 Zeilen und nur nach Nummer und Kennzeichen. Jetzt durchsucht das Suchfeld jeden Auftrag: nach Kennzeichen, Fahrgestellnummer, Marke oder Modell, Kunde, Name oder Artikelnummer eines Teils oder einer Leistung, Barcode und Notizen. Ältere Aufträge verstecken sich nicht mehr hinter der ersten Seite.",
      cn: "工单列表以前只搜索前 50 行，且仅按编号和车牌。现在搜索框会查找所有工单：按车牌、车架号、车辆品牌或型号、客户、其中配件或服务的名称或 SKU、条形码和备注。较早的工单不再被隐藏在第一页之后。",
      ro: "Lista fișelor de lucru căuta doar în primele 50 de rânduri și doar după număr și numărul de înmatriculare. Acum câmpul de căutare parcurge toate fișele: după număr de înmatriculare, serie șasiu, marca sau modelul vehiculului, client, numele ori codul unei piese sau al unui serviciu, cod de bare și notițe. Fișele mai vechi nu mai rămân ascunse sub prima pagină.",
      svn: "Seznam delovnih nalogov je iskal le po prvih 50 vrsticah in samo po številki in registrski tablici. Zdaj iskalno polje preišče vse delovne naloge: po registrski tablici, številki šasije, znamki ali modelu vozila, stranki, imenu ali šifri dela ali storitve, črtni kodi in opombah. Starejši delovni nalogi niso več skriti pod prvo stranjo.",
    },
  },
];

export default serviceEntries;
